const COPY = {
  en: {
    eyebrow: "Official macOS installer",
    title: "Download JOBolar for macOS",
    body: "You’re about to download the official JOBolar.Ai Interview Assistant installer.",
    securityTitle: "Apple notarized",
    securityDetail: "Developer ID signed",
    compatibilityTitle: "Universal build",
    compatibilityDetail: "Apple Silicon + Intel",
    sizeTitle: "Download size",
    sizeDetail: "~399 MB",
    requirementTitle: "Requires",
    requirementDetail: "macOS 13 or later",
    download: "Download .dmg",
    cancel: "Not now",
    footer: "After downloading, open the DMG and move JOBolar.Ai Interview Assistant to Applications.",
    close: "Close download dialog",
  },
  fr: {
    eyebrow: "Programme d’installation macOS officiel",
    title: "Télécharger JOBolar pour macOS",
    body: "Vous êtes sur le point de télécharger le programme d’installation officiel de JOBolar.Ai Interview Assistant.",
    securityTitle: "Notarisé par Apple",
    securityDetail: "Signé avec Developer ID",
    compatibilityTitle: "Version universelle",
    compatibilityDetail: "Apple Silicon + Intel",
    sizeTitle: "Taille du téléchargement",
    sizeDetail: "~399 Mo",
    requirementTitle: "Nécessite",
    requirementDetail: "macOS 13 ou version ultérieure",
    download: "Télécharger le .dmg",
    cancel: "Pas maintenant",
    footer: "Après le téléchargement, ouvrez le DMG et déplacez JOBolar.Ai Interview Assistant vers Applications.",
    close: "Fermer la fenêtre de téléchargement",
  },
  de: {
    eyebrow: "Offizielles macOS-Installationsprogramm",
    title: "JOBolar für macOS herunterladen",
    body: "Sie laden gleich das offizielle Installationsprogramm von JOBolar.Ai Interview Assistant herunter.",
    securityTitle: "Von Apple notarisiert",
    securityDetail: "Mit Developer ID signiert",
    compatibilityTitle: "Universeller Build",
    compatibilityDetail: "Apple Silicon + Intel",
    sizeTitle: "Downloadgröße",
    sizeDetail: "~399 MB",
    requirementTitle: "Voraussetzung",
    requirementDetail: "macOS 13 oder neuer",
    download: ".dmg herunterladen",
    cancel: "Nicht jetzt",
    footer: "Öffnen Sie nach dem Download die DMG-Datei und verschieben Sie JOBolar.Ai Interview Assistant in Programme.",
    close: "Download-Dialog schließen",
  },
  es: {
    eyebrow: "Instalador oficial para macOS",
    title: "Descargar JOBolar para macOS",
    body: "Estás a punto de descargar el instalador oficial de JOBolar.Ai Interview Assistant.",
    securityTitle: "Notarizado por Apple",
    securityDetail: "Firmado con Developer ID",
    compatibilityTitle: "Compilación universal",
    compatibilityDetail: "Apple Silicon + Intel",
    sizeTitle: "Tamaño de descarga",
    sizeDetail: "~399 MB",
    requirementTitle: "Requiere",
    requirementDetail: "macOS 13 o posterior",
    download: "Descargar .dmg",
    cancel: "Ahora no",
    footer: "Después de descargarlo, abre el DMG y mueve JOBolar.Ai Interview Assistant a Aplicaciones.",
    close: "Cerrar ventana de descarga",
  },
} as const;

export function getMacDownloadContent(locale: string) {
  return COPY[locale as keyof typeof COPY] ?? COPY.en;
}
